import { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Mousewheel, A11y, Keyboard } from 'swiper'
import {JSONFetcher, ApiQuery, findApiV4Link} from 'shared'
import { Modal } from 'react-overlays'

SwiperCore.use([Navigation, Mousewheel, A11y, Keyboard])
export class Gallery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: window.location.hash === '#gallery',
      data: [],
      current_page: 0
    }
  }

  nextPageUrl = () => {
    let query = new ApiQuery(this.props.apiUrl)
    return query.per(3).page(this.state.current_page + 1).toUrl()
  }

  loadMore = (swiper) => {
    if (this.state.current_page == this.state.total_pages) return

    JSONFetcher.load({
      url:     this.nextPageUrl(),
      success: (resp) => {
        resp.data = this.state.data.concat(resp.data)
        this.setState(resp)
      }
    })
  }

  componentDidMount() {
    // Expose open and close functions
    window.openGallery  = this.open
    window.closeGallery = this.close

    JSONFetcher.load({
      url:     this.nextPageUrl(),
      success: (resp) => { this.setState(resp) }
    })
  }

  open = (index = 0) => {
    this.setState({ isOpen: true })
    if (index) this.swiper.slideTo(index)
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  render() {
    if (!this.state.total_entries) return null

    let content = this.state.data.map(
      (picture, index) => {
        return <SwiperSlide key={ picture.id + Math.random() } >
          <Picture { ...picture } index={ index } total={ this.state.total_entries } close={ this.close } />
        </SwiperSlide>
      }
    )

    return (
      <Modal
        aria-labelledby='modal-label'
        show={this.state.isOpen}
        onHide={this.close}
        className='projects-show-gallery-modal'
        renderBackdrop={() => <div className='projects-show-gallery-modal-backdrop'></div>}
      >
        <div className='gallery-content'>
          <Swiper
            slidesPerView={1}
            navigation={{
              nextEl: '#gallery-button-next',
              prevEl: '#gallery-button-prev',
              disabledClass: 'disabled',
            }}
            scrollbar={{ hide: false }}
            keyboard={true}
            centeredSlides={true}
            roundLengths={true}
            mousewheel={{ forceToAxis: true }}
            ref={(node) => (this.swiper = node !== null ? node.swiper : null)}
            onReachEnd={this.loadMore}
          >
            {content}
          </Swiper>
          <div id='gallery-button-prev'></div>
          <div id='gallery-button-next'></div>
          <div id='gallery-button-close' onClick={this.close}></div>
        </div>
      </Modal>
    )
  }
}

const Picture = (props) => {
  const srcUrl = findApiV4Link({ofObject: props, withRel: 'image'})

  const handleClick = (event) => {
    if (event.target.className == 'fake-backdrop') {
      event.preventDefault()
      props.close()
    }
  }

  return <div className='swiper-slide text-center'>
    <div className='fake-backdrop' onClick={handleClick}>
      <img src={srcUrl} className='gallery-image' />
      <div className='gallery-description p-t'>
        <p>{props.description}</p>
        {props.index + 1} / {props.total}
      </div>
    </div>
  </div>
}
